<template>
<card-list-item :isModal="isModal" :itemImage="address + item.image" :itemTitle = "item.name" :showIndicator = 'item.selected' @card-item-clicked = 'onTrainClicked'>
  <div slot = 'title'>
    <div class="cart-item-title" :class="{'cart-item-pic-mode': isModal}">{{item.name}}</div>
    <level :level = 'item.level'/>
  </div>
  <mu-icon  slot = 'indicator' value = 'done' color = 'rgba(255, 255, 255, 0.6)' :size = '144'/>
</card-list-item>
</template>

<script>
import TrainCardController from './controller';
export default new TrainCardController();
</script>
<style>
.cart-item-title{
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis; 
  white-space: nowrap;
}
.cart-item-pic-mode{
  max-width: 144px !important;
}
</style>



// WEBPACK FOOTER //
// component.vue?1ff65259